/* eslint-disable no-param-reassign */
import { Container } from '@tencent/alloy-renderer';
import {
    InterfaceRendererImageComponent,
    InterfaceRendererShapeComponent,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/types';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { ptToCanvas } from '@src/slide/infrastructure/module/independent/unit';
import PlayIcon from '@src/img/play-icon-for-video.svg';
import { getTargetComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/anim-component-relate';
import { isVideoElement } from '@src/slide/domain/ui-model/elements/element-judge';
import { GraphicsRenderComponent } from '@tencent/alloy-graphics';
import { generateGraphicsModel } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/graphic-adapter/generate-graphics-model';
import { reverseComponentFlip } from '../reverse-component-flip';
import { RenderPositionToMediaRegion, RenderPostionType } from '@src/js/constant';

const PLAY_ICON_WIDTH = ptToCanvas(72);
const PLAY_ICON_HEIGHT = ptToCanvas(72);
export class PlayerIconComponent {
    public factoryOptions: InterfaceFactoryOptions;
    public flagGraphics: Container | null;
    public readonly parentComponent: InterfaceRendererImageComponent | InterfaceRendererShapeComponent;

    public constructor(
        factoryOptions: InterfaceFactoryOptions,
        parentComponent: InterfaceRendererImageComponent | InterfaceRendererShapeComponent,
    ) {
        this.factoryOptions = factoryOptions;
        this.parentComponent = parentComponent;
        this.updateComponent();
    }

    public updateComponent = (): void => {
        const { model, region, mediaManager } = this.factoryOptions;

        if (isVideoElement(model)) {
            if ([RenderPostionType.CANVAS, RenderPostionType.PLAYER].includes(region)) {
                const shouldShowMediaEle = mediaManager?.shouldShowMediaElement(
                    model.key,
                    model.id as string,
                    RenderPositionToMediaRegion[region],
                );
                this.updateAlpha(shouldShowMediaEle ? 0 : 1);
            }
            this.renderFlagIcon();
        } else {
            this.removeFlagGraphics();
        }
    };

    protected removeFlagGraphics() {
        if (this.flagGraphics) {
            this.parentComponent.removeChild(this.flagGraphics);
            this.flagGraphics.dispose();
            this.flagGraphics = null;
        }
    }

    protected renderFlagIcon = () => {
        if (!this.flagGraphics) {
            const iconGraphic = this.getIconGraphic();
            // 没有则创建
            this.flagGraphics = new Container();
            this.flagGraphics.addChild(iconGraphic);
            this.parentComponent.addChild(this.flagGraphics);
        } else {
            const iconGraphic = this.flagGraphics.children[0] as Container;
            this.updateCursor(iconGraphic);
            this.updateIconGraphicPosition(iconGraphic);
        }
        this.flagGraphics = reverseComponentFlip(this.flagGraphics, this.factoryOptions);
    };

    protected getImgStyle() {
        return {
            fillBackground: {
                image: {
                    src: PlayIcon,
                },
            },
            width: PLAY_ICON_WIDTH,
            height: PLAY_ICON_HEIGHT,
        };
    }

    protected getIconGraphic(): Container {
        const imgStyle = this.getImgStyle();
        const imgGraphicsModel = generateGraphicsModel({ style: imgStyle, factoryOptions: this.factoryOptions });
        const imgGraphics = new GraphicsRenderComponent(imgGraphicsModel);
        this.updateCursor(imgGraphics);
        this.updateIconGraphicPosition(imgGraphics);
        return imgGraphics;
    }

    private updateCursor(iconGraphic: Container) {
        const animWrapper = getTargetComponent(
            this.parentComponent.factoryOptions.model.rootGroupModel?.key
                ?? this.parentComponent.factoryOptions.model.key,
            this.factoryOptions.animManager?.playSlideComponent,
        );

        if (animWrapper?.alpha === 0) {
            iconGraphic.cursor = 'auto';
        } else {
            iconGraphic.cursor = 'pointer';
        }
    }

    /**
     * 更新 icon 位置，保证居中
     * @param iconGraphic
     */
    private updateIconGraphicPosition(iconGraphic: Container) {
        const { width: modelWidth, height: modelHeight } = this.factoryOptions.frame!;
        iconGraphic.x = (modelWidth - PLAY_ICON_WIDTH) / 2;
        iconGraphic.y =  (modelHeight - PLAY_ICON_HEIGHT) / 2;
    }

    private updateAlpha(alpha: number) {
        if (this.flagGraphics) {
            this.flagGraphics.alpha = alpha;
        }
    }
}
